import React from "react";

export default class PageLoaded extends React.Component {
  componentDidMount = () => document.body.classList.add("loaded");
  render = () => null;
}
